exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-14844bc0] .agreementDia-cla .el-dialog__body{padding:.833333rem!important;height:50vh;overflow:auto}.validate-row[data-v-14844bc0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;height:4.166667rem;line-height:4.166667rem;padding:0 1.666667rem}.validate-row>div[data-v-14844bc0]{margin-right:1.666667rem}.export-btn[data-v-14844bc0]{margin-left:.416667rem;cursor:pointer;color:#4db22f}[data-v-14844bc0] .validataDia-cla{min-width:41.666667rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-14844bc0","scoped":true,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":12}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/personCenter/dialog/cancelAccount.vue
// module id = YfXm
// module chunks = 9